import { Layers, LayoutGrid } from 'lucide-react';
import { useLandingVariant } from '../contexts/LandingVariantContext';

interface LandingVariantSwitcherProps {
  className?: string;
  showLabel?: boolean;
}

export function LandingVariantSwitcher({ className = '', showLabel = true }: LandingVariantSwitcherProps) {
  const { variant, toggleVariant } = useLandingVariant();
  const isV2 = variant === 'v2';

  return (
    <button
      onClick={toggleVariant}
      className={`
        inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium
        bg-surface-700 hover:bg-surface-600
        border border-surface-500 rounded-lg
        text-text-secondary hover:text-text-primary
        transition-all duration-200
        ${className}
      `}
      title={`Switch to ${isV2 ? 'Original' : 'V2'} landing page`}
    >
      {isV2 ? (
        <LayoutGrid size={16} className="text-primary-400" />
      ) : (
        <Layers size={16} className="text-accent-400" />
      )}
      {showLabel && (
        <span>{isV2 ? 'Original' : 'Try V2'}</span>
      )}
    </button>
  );
}
